import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { ShieldCheck, Rocket, Loader2 } from "lucide-react";

/** Admin panel — grant/revoke programme review & publish authority to clinicians.
 *  Admins hold both by default (experienced clinicians); this only manages
 *  additional grants to ordinary clinicians. */
export const CapabilityPanel = () => {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(null);

  const load = () => api.get("/admin/programme-capabilities").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (u, key) => {
    setBusy(`${u.id}-${key}`);
    try {
      const body = key === "review" ? { can_review_programmes: !u.review_granted } : { can_publish_programmes: !u.publish_granted };
      await api.put(`/admin/programme-capabilities/${u.id}`, body);
      toast.success("Capability updated");
      await load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(null); }
  };

  return (
    <div className="fl-card p-3 space-y-2 text-xs" data-testid="capability-panel">
      <b className="text-zinc-100 text-sm">Programme capabilities</b>
      <div className="text-zinc-500">Admins can review & publish by default. Grant extra authority to clinicians here. A reviewer can never approve a version they authored.</div>
      <div className="space-y-1 mt-2">
        {rows.map((u) => (
          <div key={u.id} className="flex items-center gap-2 rounded border border-zinc-800 px-2 py-1.5" data-testid={`cap-row-${u.id}`}>
            <div className="min-w-0 flex-1">
              <div className="text-zinc-100 truncate">{u.name || u.email} <span className="text-zinc-500">· {u.role}</span></div>
            </div>
            {u.role === "admin" ? (
              <span className="text-emerald-400">Review & publish (default)</span>
            ) : (
              <div className="flex items-center gap-1">
                <button className={`fl-btn-ghost px-2 py-1 ${u.review_granted ? "text-emerald-400" : "text-zinc-400"}`} onClick={() => toggle(u, "review")} disabled={busy === `${u.id}-review`} data-testid={`cap-review-${u.id}`}>
                  {busy === `${u.id}-review` ? <Loader2 size={12} className="animate-spin" /> : <ShieldCheck size={12} />} Review {u.review_granted ? "✓" : ""}
                </button>
                <button className={`fl-btn-ghost px-2 py-1 ${u.publish_granted ? "text-emerald-400" : "text-zinc-400"}`} onClick={() => toggle(u, "publish")} disabled={busy === `${u.id}-publish`} data-testid={`cap-publish-${u.id}`}>
                  {busy === `${u.id}-publish` ? <Loader2 size={12} className="animate-spin" /> : <Rocket size={12} />} Publish {u.publish_granted ? "✓" : ""}
                </button>
              </div>
            )}
          </div>
        ))}
        {!rows.length && <div className="text-zinc-500">No staff found.</div>}
      </div>
    </div>
  );
};
